import { Container, Row } from "react-bootstrap";
import { Title } from "../components/common/Title";
import { Epic } from "../types/Epic";
import moment from "moment";
import { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

import { getEpicColor } from "../utils/epicColors";

import "react-big-calendar/lib/css/react-big-calendar.css";

import "./styles.css";

const epicMinutes: { [key: string]: number } = {
  fractals: 15,
  genie: 30,
  if1: 30,
  if2: 30,
  inferno: 30,
  oc: 15,
  transcendence: 30,
  winds: 15
};

const parseEpics = (epics: Epic[]) => {
  if (epics?.length > 0) {
    const res: {
      id: string;
      title: string;
      start: string;
      end: string;
      backgroundColor: string;
      borderColor: string;
      textColor: string;
    }[] = [];
    epics.forEach((epic: Epic) => {
      let _startTime = moment(epic.startTimestamp);
      const _splitEpics = epic.epics.split(", ");
      _splitEpics.forEach((e: string) => {
        const duration = epicMinutes[e.toLowerCase()] || 0;
        const endTime = _startTime.clone().add(duration, "minutes");

        res.push({
          id: `${epic.id}_${e}`,
          title: e,
          start: _startTime.toISOString(),
          end: endTime.toISOString(),
          backgroundColor: getEpicColor(e),
          borderColor: getEpicColor(e),
          textColor: "#161523"
        });

        _startTime = endTime;
      });
    });
    return res;
  }

  return [];
};

export const EpicsCalendar = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_HOST = "https://lightclan.net/api/";

    // fetch data
    const dataFetch = async () => {
      const data = await (await fetch(`${API_HOST}public/epics`)).json();

      // set state when the data received
      setData(data);
      setLoading(false);
    };

    dataFetch();

    // Re-fetch timer
    const timeToFetch = 5 * 60 * 1000;
    const interval = setInterval(() => {
      dataFetch();
    }, timeToFetch);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      <Row>
        <Title text="Epics Schedule (your local time)" />
      </Row>
      <Row>
        {loading && (
          <div className="spinner-border text-warning" role="status">
            <span className="sr-only" />
          </div>
        )}
        {!loading && (
          <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            events={parseEpics(data)}
            eventDisplay="block"
            eventTimeFormat={{
              hour: "2-digit",
              minute: "2-digit",
              hour12: false // Ensures 12-hour format with AM/PM
            }}
          />
        )}
      </Row>
    </Container>
  );
};
